import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from "@angular/core";
import { Subscription } from "rxjs";

import {
    GridFacade,
    GridFilterGroup,
    PriceRange,
} from "@hermes/states/grid-filters-state";
import { FocusService } from "@hermes/utils-generic/services/focus";

import {
    getHighestPrice,
    getLowestPrice,
} from "app/pages/grid-page/services/filter-slider-helper/filter-slider.helper";

@Component({
    selector: "h-grid-filters-slider",
    templateUrl: "./grid-filters-slider.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFiltersSliderComponent implements OnChanges, OnDestroy {
    @Input()
    public filterGroup: GridFilterGroup;

    @Input()
    public isExpanded: boolean;

    public priceRange: PriceRange;

    private subscription: Subscription = new Subscription();

    constructor(
        private gridFacade: GridFacade,
        private focusService: FocusService,
        private cd: ChangeDetectorRef,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (
            !changes.filterGroup ||
            JSON.stringify(changes.filterGroup.currentValue) ===
                JSON.stringify(changes.filterGroup.previousValue)
        ) {
            return;
        }
        this.filterGroup = changes.filterGroup.currentValue;
        // if those params exist use it
        if (this.filterGroup.priceRange) {
            this.priceRange = this.filterGroup.priceRange;
            return;
        }
        const maxPrice = getHighestPrice(this.filterGroup);
        const minPrice = getLowestPrice(this.filterGroup);
        this.priceRange = {
            valueMin: minPrice,
            valueMinCurrent: minPrice,
            valueMaxCurrent: maxPrice,
            valueMax: maxPrice,
        };
        this.cd.markForCheck();
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public onValueChange(prices: PriceRange): void {
        if (prices) {
            if (
                prices.valueMaxCurrent === prices.valueMax &&
                prices.valueMinCurrent === prices.valueMin
            ) {
                this.gridFacade.clearPriceFilter();
            } else {
                this.gridFacade.updateGridFilterPrice(prices);
                this.focusService.elementToFocus = prices.valueChanged;
            }
        }
    }
}
